/*
Purpose: Shared request-inbox tab definitions for Filters summary and Requests panel.
*/

import BlockIcon from '@mui/icons-material/Block';
import DeleteSweepOutlinedIcon from '@mui/icons-material/DeleteSweepOutlined';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import StarOutlineIcon from '@mui/icons-material/StarOutline';

import { CALENDAR_VIEW } from './constants';

export const INBOX_TABS = [
  {
    id: CALENDAR_VIEW.DEFER_REQUESTS,
    label: 'Defer',
    fullTitle: 'Defer requests',
    countKey: 'deferRequests',
    icon: EventRepeatIcon,
  },
  {
    id: CALENDAR_VIEW.DEFER_BIN,
    label: 'Deferred bin',
    fullTitle: 'Deferred bin',
    countKey: 'deferBin',
    icon: DeleteSweepOutlinedIcon,
  },
  {
    id: CALENDAR_VIEW.ONE_OFF_REQUESTS,
    label: 'One-off',
    fullTitle: 'One-off requests',
    countKey: 'oneOffRequests',
    icon: StarOutlineIcon,
  },
  {
    id: CALENDAR_VIEW.DISAPPROVED,
    label: 'Disapproved',
    fullTitle: 'Disapproved requests',
    countKey: 'disapproved',
    icon: BlockIcon,
  },
];

export const INBOX_IDS = INBOX_TABS.map((tab) => tab.id);
